
import { useState, useEffect, useRef } from "react";
import axios from "axios";

function TechnicianSelector({ onSelect }) {

const [technicians,setTechnicians]=useState([]);
const [search,setSearch]=useState("");

const [selectedIndex,
setSelectedIndex]=useState(-1);

const searchInputRef=useRef(null);

const loadTechnicians=async()=>{

try{

const token=
localStorage.getItem("token");

const response=
await axios.get(

"https://saleupcall.com/api/Technician/get-technicians.php",

{
headers:{
Authorization:
`Bearer ${token}`
}
}

);

if(response.data.status){

setTechnicians(
response.data.data || []
);

}

}
catch(error){

console.log(error);

}

};

useEffect(()=>{

loadTechnicians();

},[]);

useEffect(()=>{

const timer=
setTimeout(()=>{

searchInputRef.current?.focus();

},200);

return()=>clearTimeout(timer);

},[]);


// Search se matching row select

useEffect(()=>{

if(search===""){

setSelectedIndex(-1);

return;

}

const index=

technicians.findIndex(

(technician)=>

(technician.username || "")
.toLowerCase()
.startsWith(
search.toLowerCase()
)

||

(technician.employee_code || "")
.toLowerCase()
.startsWith(
search.toLowerCase()
)

);

setSelectedIndex(index);

},[search,technicians]);

return(

<>

<input

ref={searchInputRef}

type="text"

className="form-control mb-2"

placeholder="Search Technician"

value={search}

onChange={(e)=>
setSearch(
e.target.value
)
}

onKeyDown={(e)=>{

// Down arrow

if(e.key==="ArrowDown"){

e.preventDefault();

setSelectedIndex((prev)=>{

if(prev===-1){

return 0;

}

return Math.min(
prev+1,
technicians.length-1
);

});

}


// Up arrow

if(e.key==="ArrowUp"){

e.preventDefault();

setSelectedIndex((prev)=>{

return Math.max(
prev-1,
0
);

});

}


// Enter

if(
e.key==="Enter"
&&
technicians[selectedIndex]
){

e.preventDefault();

onSelect({

id:
technicians[selectedIndex].id,

name:
technicians[selectedIndex]
.username

});

}

}}

style={{
caretColor:"black"
}}

/>


<div
style={{
maxHeight:"400px",
overflow:"auto"
}}
>

<table
className="table table-bordered table-hover table-sm"
>

<thead
className="table-success"
>

<tr>

<th>ID</th>
<th>Employee Code</th>
<th>Username</th>
<th>Mobile</th>
<th>Department</th>

</tr>

</thead>

<tbody>

{

technicians.map(

(technician,index)=>(

<tr

key={technician.id}

className={
index===selectedIndex
?
"table-primary"
:
""
}

style={{
cursor:"pointer"
}}

onClick={()=>{

setSelectedIndex(index);

onSelect({

id:technician.id,

name:technician.username

});

}}

>

<td>{technician.id}</td>

<td>
{technician.employee_code}
</td>

<td>
{technician.username}
</td>

<td>
{technician.mobile}
</td>

<td>
{technician.department_name}
</td>

</tr>

)

)

}

</tbody>

</table>

</div>

</>

);

}

export default TechnicianSelector;

